import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './responsive.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'
import { RouteContext } from './context/RouteContext.tsx'
import { bootstrapDataLayer, track } from './lib/analytics';
import { onLCP, onINP, onCLS } from 'web-vitals';

bootstrapDataLayer();

function sendWebVitals({ name, value }: { name: string; value: number }) {
  track('web_vitals', {
    element_label: name,
    duration_ms: Math.round(value),
  });
}

onLCP(sendWebVitals);
onINP(sendWebVitals);
onCLS(sendWebVitals);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouteContext.Provider value={window.location.pathname}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </RouteContext.Provider>
  </StrictMode>,
)
